module.exports = __webpack_public_path__ + "static/media/poll-fill.d4722609.svg";